import { Machine } from 'xstate';

export const STEPS = Object.seal({
  ON_PROSPECTION: 'on_prospection',
  CONTACTED: 'contacted',
  CONTACT: 'contact',
  ENGAGED: 'engaged',
  MEETING: 'meeting',
  ACCOUNT: 'account',
  NURTURING: 'nurturing',
  DISCARDED: 'discarded',
  ON_HOLD: 'on_hold',
});

const statusMachine = Machine({
  id: 'status',
  type: 'parallel',
  states: {
    lead: {
      initial: STEPS.ON_PROSPECTION,
      states: {
        on_prospection: {
          on: {
            SET_ON_PROSPECTION_LEAD: STEPS.ON_PROSPECTION,
            SET_CONTACTED_LEAD: STEPS.CONTACTED,
            SET_ENGAGED_LEAD: STEPS.ENGAGED,
            SET_MEETING_LEAD: STEPS.MEETING,
            SET_CONTACT_LEAD: STEPS.CONTACT,
            SET_NURTURING_LEAD: STEPS.NURTURING,
            SET_NURTURING_COMPANY: STEPS.NURTURING,
            SET_DISCARDED_LEAD: STEPS.DISCARDED,
            SET_DISCARDED_COMPANY: STEPS.DISCARDED,
            SET_ON_HOLD_LEAD: STEPS.ON_HOLD,
            SET_ON_HOLD_COMPANY: STEPS.ON_HOLD,
          },
        },
        contacted: {
          on: {
            SET_ON_PROSPECTION_LEAD: STEPS.ON_PROSPECTION,
            SET_ENGAGED_LEAD: STEPS.ENGAGED,
            SET_MEETING_LEAD: STEPS.MEETING,
            SET_CONTACT_LEAD: STEPS.CONTACT,
            SET_NURTURING_LEAD: STEPS.NURTURING,
            SET_NURTURING_COMPANY: STEPS.NURTURING,
            SET_DISCARDED_LEAD: STEPS.DISCARDED,
            SET_DISCARDED_COMPANY: STEPS.DISCARDED,
            SET_ON_HOLD_LEAD: STEPS.ON_HOLD,
            SET_ON_HOLD_COMPANY: STEPS.ON_HOLD,
          },
        },
        engaged: {
          on: {
            SET_ON_PROSPECTION_LEAD: STEPS.ON_PROSPECTION,
            SET_CONTACTED_LEAD: STEPS.CONTACTED,
            SET_MEETING_LEAD: STEPS.MEETING,
            SET_CONTACT_LEAD: STEPS.CONTACT,
            SET_NURTURING_LEAD: STEPS.NURTURING,
            SET_NURTURING_COMPANY: STEPS.NURTURING,
            SET_DISCARDED_LEAD: STEPS.DISCARDED,
            SET_DISCARDED_COMPANY: STEPS.DISCARDED,
            SET_ON_HOLD_LEAD: STEPS.ON_HOLD,
            SET_ON_HOLD_COMPANY: STEPS.ON_HOLD,
          },
        },
        meeting: {
          on: {
            SET_ON_PROSPECTION_LEAD: STEPS.ON_PROSPECTION,
            SET_CONTACTED_LEAD: STEPS.CONTACTED,
            SET_ENGAGED_LEAD: STEPS.ENGAGED,
            SET_CONTACT_LEAD: STEPS.CONTACT,
            SET_NURTURING_LEAD: STEPS.NURTURING,
            SET_NURTURING_COMPANY: STEPS.NURTURING,
            SET_DISCARDED_LEAD: STEPS.DISCARDED,
            SET_DISCARDED_COMPANY: STEPS.DISCARDED,
            SET_ON_HOLD_LEAD: STEPS.ON_HOLD,
            SET_ON_HOLD_COMPANY: STEPS.ON_HOLD,
          },
        },
        contact: {
          on: {
            SET_ON_PROSPECTION_LEAD: STEPS.ON_PROSPECTION,
            SET_CONTACTED_LEAD: STEPS.CONTACTED,
            SET_ENGAGED_LEAD: STEPS.ENGAGED,
            SET_MEETING_LEAD: STEPS.MEETING,
            SET_DISCARDED_LEAD: STEPS.DISCARDED,
            SET_NURTURING_LEAD: STEPS.NURTURING,
            SET_DISCARDED_COMPANY: STEPS.DISCARDED,
            SET_NURTURING_COMPANY: STEPS.NURTURING,
            SET_ON_HOLD_LEAD: STEPS.ON_HOLD,
            SET_ON_HOLD_COMPANY: STEPS.ON_HOLD,
          },
        },
        nurturing: {
          on: {
            SET_ON_PROSPECTION_LEAD: STEPS.ON_PROSPECTION,
            SET_CONTACTED_LEAD: STEPS.CONTACTED,
            SET_ENGAGED_LEAD: STEPS.ENGAGED,
            SET_MEETING_LEAD: STEPS.MEETING,
            SET_CONTACT_LEAD: STEPS.CONTACT,
            SET_DISCARDED_LEAD: STEPS.DISCARDED,
            SET_DISCARDED_COMPANY: STEPS.DISCARDED,
            SET_ON_HOLD_LEAD: STEPS.ON_HOLD,
            SET_ON_HOLD_COMPANY: STEPS.ON_HOLD,
          },
        },
        discarded: {
          on: {
            SET_ON_PROSPECTION_LEAD: STEPS.ON_PROSPECTION,
            SET_CONTACTED_LEAD: STEPS.CONTACTED,
            SET_ENGAGED_LEAD: STEPS.ENGAGED,
            SET_MEETING_LEAD: STEPS.MEETING,
            SET_CONTACT_LEAD: STEPS.CONTACT,
            SET_NURTURING_LEAD: STEPS.NURTURING,
            SET_NURTURING_COMPANY: STEPS.NURTURING,
            SET_ON_HOLD_LEAD: STEPS.ON_HOLD,
            SET_ON_HOLD_COMPANY: STEPS.ON_HOLD,
          },
        },
        on_hold: {
          on: {
            SET_ON_PROSPECTION_LEAD: STEPS.ON_PROSPECTION,
            SET_CONTACTED_LEAD: STEPS.CONTACTED,
            SET_ENGAGED_LEAD: STEPS.ENGAGED,
            SET_MEETING_LEAD: STEPS.MEETING,
            SET_CONTACT_LEAD: STEPS.CONTACT,
            SET_NURTURING_LEAD: STEPS.NURTURING,
            SET_NURTURING_COMPANY: STEPS.NURTURING,
            SET_DISCARDED_LEAD: STEPS.DISCARDED,
            SET_DISCARDED_COMPANY: STEPS.DISCARDED,
          },
        },
      },
    },
    company: {
      initial: STEPS.ON_PROSPECTION,
      states: {
        on_prospection: {
          on: {
            SET_ON_PROSPECTION_COMPANY: STEPS.ON_PROSPECTION,
            SET_ON_PROSPECTION_LEAD: STEPS.ON_PROSPECTION,
            SET_CONTACTED_COMPANY: STEPS.CONTACTED,
            SET_CONTACTED_LEAD: STEPS.CONTACTED,
            SET_ENGAGED_COMPANY: STEPS.ENGAGED,
            SET_ENGAGED_LEAD: STEPS.ENGAGED,
            SET_MEETING_COMPANY: STEPS.MEETING,
            SET_MEETING_LEAD: STEPS.MEETING,
            SET_CONTACT_LEAD: STEPS.ACCOUNT,
            SET_ACCOUNT_COMPANY: STEPS.ACCOUNT,
            SET_NURTURING_COMPANY: STEPS.NURTURING,
            SET_DISCARDED_COMPANY: STEPS.DISCARDED,
            SET_ON_HOLD_COMPANY: STEPS.ON_HOLD,
          },
        },
        contacted: {
          on: {
            SET_ON_PROSPECTION_COMPANY: STEPS.ON_PROSPECTION,
            SET_ON_PROSPECTION_LEAD: STEPS.ON_PROSPECTION,
            SET_ENGAGED_COMPANY: STEPS.ENGAGED,
            SET_ENGAGED_LEAD: STEPS.ENGAGED,
            SET_MEETING_COMPANY: STEPS.MEETING,
            SET_MEETING_LEAD: STEPS.MEETING,
            SET_CONTACT_LEAD: STEPS.ACCOUNT,
            SET_ACCOUNT_COMPANY: STEPS.ACCOUNT,
            SET_NURTURING_COMPANY: STEPS.NURTURING,
            SET_DISCARDED_COMPANY: STEPS.DISCARDED,
            SET_ON_HOLD_COMPANY: STEPS.ON_HOLD,
          },
        },
        engaged: {
          on: {
            SET_ON_PROSPECTION_COMPANY: STEPS.ON_PROSPECTION,
            SET_ON_PROSPECTION_LEAD: STEPS.ON_PROSPECTION,
            SET_CONTACTED_LEAD: STEPS.CONTACTED,
            SET_CONTACTED_COMPANY: STEPS.CONTACTED,
            SET_ENGAGED_COMPANY: STEPS.ENGAGED,
            SET_ENGAGED_LEAD: STEPS.ENGAGED,
            SET_MEETING_COMPANY: STEPS.MEETING,
            SET_MEETING_LEAD: STEPS.MEETING,
            SET_CONTACT_LEAD: STEPS.ACCOUNT,
            SET_ACCOUNT_COMPANY: STEPS.ACCOUNT,
            SET_NURTURING_COMPANY: STEPS.NURTURING,
            SET_DISCARDED_COMPANY: STEPS.DISCARDED,
            SET_ON_HOLD_COMPANY: STEPS.ON_HOLD,
          },
        },
        meeting: {
          on: {
            SET_ON_PROSPECTION_COMPANY: STEPS.ON_PROSPECTION,
            SET_ON_PROSPECTION_LEAD: STEPS.ON_PROSPECTION,
            SET_CONTACTED_COMPANY: STEPS.CONTACTED,
            SET_CONTACTED_LEAD: STEPS.CONTACTED,
            SET_ENGAGED_COMPANY: STEPS.ENGAGED,
            SET_ENGAGED_LEAD: STEPS.ENGAGED,
            SET_CONTACT_LEAD: STEPS.ACCOUNT,
            SET_ACCOUNT_COMPANY: STEPS.ACCOUNT,
            SET_NURTURING_COMPANY: STEPS.NURTURING,
            SET_DISCARDED_COMPANY: STEPS.DISCARDED,
            SET_ON_HOLD_COMPANY: STEPS.ON_HOLD,
          },
        },
        account: {
          on: {
            SET_ON_PROSPECTION_COMPANY: STEPS.ON_PROSPECTION,
            SET_ON_PROSPECTION_LEAD: STEPS.ON_PROSPECTION,
            SET_CONTACTED_COMPANY: STEPS.CONTACTED,
            SET_CONTACTED_LEAD: STEPS.CONTACTED,
            SET_ENGAGED_COMPANY: STEPS.ENGAGED,
            SET_ENGAGED_LEAD: STEPS.ENGAGED,
            SET_MEETING_COMPANY: STEPS.MEETING,
            SET_MEETING_LEAD: STEPS.MEETING,
            SET_NURTURING_COMPANY: STEPS.NURTURING,
            SET_DISCARDED_COMPANY: STEPS.DISCARDED,
            SET_ON_HOLD_COMPANY: STEPS.ON_HOLD,
          },
        },
        nurturing: {
          on: {
            SET_ON_PROSPECTION_COMPANY: STEPS.ON_PROSPECTION,
            SET_ON_PROSPECTION_LEAD: STEPS.ON_PROSPECTION,
            SET_CONTACTED_COMPANY: STEPS.CONTACTED,
            SET_CONTACTED_LEAD: STEPS.CONTACTED,
            SET_ENGAGED_COMPANY: STEPS.ENGAGED,
            SET_ENGAGED_LEAD: STEPS.ENGAGED,
            SET_MEETING_COMPANY: STEPS.MEETING,
            SET_MEETING_LEAD: STEPS.MEETING,
            SET_CONTACT_LEAD: STEPS.ACCOUNT,
            SET_ACCOUNT_COMPANY: STEPS.ACCOUNT,
            SET_DISCARDED_COMPANY: STEPS.DISCARDED,
            SET_ON_HOLD_COMPANY: STEPS.ON_HOLD,
          },
        },
        discarded: {
          on: {
            SET_ON_PROSPECTION_COMPANY: STEPS.ON_PROSPECTION,
            SET_ON_PROSPECTION_LEAD: STEPS.ON_PROSPECTION,
            SET_CONTACTED_COMPANY: STEPS.CONTACTED,
            SET_CONTACTED_LEAD: STEPS.CONTACTED,
            SET_ENGAGED_COMPANY: STEPS.ENGAGED,
            SET_ENGAGED_LEAD: STEPS.ENGAGED,
            SET_MEETING_COMPANY: STEPS.MEETING,
            SET_MEETING_LEAD: STEPS.MEETING,
            SET_CONTACT_LEAD: STEPS.ACCOUNT,
            SET_ACCOUNT_COMPANY: STEPS.ACCOUNT,
            SET_NURTURING_COMPANY: STEPS.NURTURING,
            SET_ON_HOLD_COMPANY: STEPS.ON_HOLD,
          },
        },
        on_hold: {
          on: {
            SET_ON_PROSPECTION_COMPANY: STEPS.ON_PROSPECTION,
            SET_ON_PROSPECTION_LEAD: STEPS.ON_PROSPECTION,
            SET_CONTACTED_COMPANY: STEPS.CONTACTED,
            SET_CONTACTED_LEAD: STEPS.CONTACTED,
            SET_ENGAGED_COMPANY: STEPS.ENGAGED,
            SET_ENGAGED_LEAD: STEPS.ENGAGED,
            SET_MEETING_COMPANY: STEPS.MEETING,
            SET_MEETING_LEAD: STEPS.MEETING,
            SET_CONTACT_LEAD: STEPS.ACCOUNT,
            SET_ACCOUNT_COMPANY: STEPS.ACCOUNT,
            SET_NURTURING_COMPANY: STEPS.NURTURING,
            SET_DISCARDED_COMPANY: STEPS.DISCARDED,
          },
        },
      },
    },
  },
});

export default statusMachine;
